import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities' 

class ClubRepository {

    constructor() {
        this.basePath = store.state.backend;
    }

    allClubs() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/clubs`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    allClubsOfUser() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/clubs/user`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getClubMember(clubMemberId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/club-members/${clubMemberId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getClubPermissions(clubId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/clubs/permissions/${clubId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    createClubMember(clubMember) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/club-members`, clubMember, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    bulkImportingOfMembers(importingData) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/clubs/members/bulk-importing`, importingData, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getAllClubMembers(clubId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/clubs/members/${clubId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getAllClubPosts(clubId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/clubs/posts/${clubId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getAllClubPostsByChannel(clubId, channelId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/clubs/posts-by-channel?clubId=${clubId}&channelId=${channelId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getAllClubEvents(clubId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/clubs/events/${clubId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getAllClubEventsByChannel(clubId, channelId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/clubs/events-by-channel?clubId=${clubId}&channelId=${channelId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    createClubPost(post) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/clubs/posts`, post,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    createClubEvent(event) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/clubs/events`, event,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    createClubChannel(channel) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/clubs/channels`, channel,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    joinClubChannelContributor(clubChannelContributor) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/clubs/channel-contributors/`, clubChannelContributor,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    modifyClubChannel(channel) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/ext/clubs/channels`, channel,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    deletePost(postId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.delete(`${this.basePath}/ext/clubs/posts/${postId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    deleteEvent(eventId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.delete(`${this.basePath}/ext/clubs/events/${eventId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    deleteClubChannel(clubChannelId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.delete(`${this.basePath}/ext/clubs/channels/${clubChannelId}/`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    deleteClubChannelContributor(clubChannelContributorId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.delete(`${this.basePath}/ext/clubs/channel-contributors/${clubChannelContributorId}/`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    changeClubMemberRol(clubMemberId, newRol) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/clubs/members/rol?memberId=${clubMemberId}&newRol=${newRol}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    denyClubMember(clubMemberId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.delete(`${this.basePath}/ext/clubs/members/${clubMemberId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getAllClubChannels(clubId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/clubs/channels/${clubId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getAllPublicClubChannels(clubId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/clubs/channels/public/${clubId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getAllClubChannelsByContributor(clubMemberId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/clubs/channel-contributors/${clubMemberId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getAllClubChannelContributors(channelId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/clubs/channel-contributors/channel/${channelId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getClubPerformance(performanceRequirements) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/clubs/performance`, performanceRequirements,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    modifyClubName(editingData) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/ext/clubs/edit-name`, editingData,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    modifyClubDescription(editingData) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/ext/clubs/edit-description`, editingData,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    modifyClubColor(editingData) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/ext/clubs/edit-color`, editingData,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }
}

export default new ClubRepository();
